<template>
  <div :class="['free-write-container', { expanded: isExpanded }]">
    <!-- 顶部操作栏 -->
    <div class="content-header">
      <div class="header-left">
        <img
          v-if="isExpanded"
          class="action-btn collapse-btn"
          @click="showHistoryList"
          :src="cdnUrl + 'ai-collaspe.svg'"
          alt=""
        />
        <button class="back-btn" @click="handleBack">
          <img :src="cdnUrl + 'ai-left-icon.svg'" alt="返回" />
        </button>
        <span class="content-title">自由创作</span>
      </div>
      <div class="content-actions">
        <template v-if="!isExpanded">
          <el-tooltip content="新建对话" placement="top">
            <img
              class="action-btn"
              @click="handleEdit"
              :src="cdnUrl + 'ai-add.svg'"
              alt=""
            />
          </el-tooltip>
          <el-tooltip content="历史对话" placement="top">
            <img
              class="action-btn"
              @click="handleRecord"
              :src="cdnUrl + 'ai-record.svg'"
              alt=""
            />
          </el-tooltip>
        </template>
        <el-tooltip v-if="isExpanded" content="收起" placement="top">
          <img
            class="action-btn"
            @click="toggleExpand"
            :src="cdnUrl + 'ai-sx.svg'"
            alt=""
          />
        </el-tooltip>
        <el-tooltip v-else content="展开" placement="top">
          <img
            class="action-btn"
            @click="toggleExpand"
            :src="cdnUrl + 'ai-full.svg'"
            alt=""
          />
        </el-tooltip>
        <img
          class="action-btn"
          @click="handleClose"
          :src="cdnUrl + 'ai-closed.svg'"
          alt=""
        />
      </div>
    </div>

    <!-- 内容区域 -->
    <div :class="['content-area', { 'content-area__fixed': chatList.length }]">
      <div
        :class="['chat_window', { chat_window__fixed: chatList.length }]"
        id="chat_window"
        v-if="chatList.length"
      >
        <div
          class="item"
          :class="item.type == 2 ? 'left' : 'right'"
          v-for="(item, index) in chatList"
          :key="index"
        >
          <div class="message" :class="item.type == 2 ? 'AI' : 'monkey'">
            <loading v-if="item.isLoading" />
            <template v-else>
              <span>{{ item.showText }}</span>
              <handle
                v-if="item.type == 2"
                :item="item"
                :copyText="item.showText"
                :type="type"
                :isCreating="isCreating"
                :showLikeAndUnlike="false"
                :showRegenerate="index + 1 == chatList.length && isNeedAgain"
                @regenerate="createAI(1, item.id)"
                @add="addFn"
              />
            </template>
          </div>
        </div>
      </div>
      <!-- 中间占位区域 -->
      <div
        class="placeholder-section"
        v-else
        :class="{ 'placeholder-section__fade': chatList.length }"
      >
        <div class="placeholder-content">
          <img :src="cdnUrl + 'ai-create.svg'" alt="" class="avatar-img" />
        </div>
      </div>

      <!-- 输入区域 -->
      <div
        class="input-section"
        :class="{ 'input-section__moving': chatList.length }"
      >
        <div class="tip-wrap-1" v-if="chatList.length">
          <div class="tips">
            每天限使用<span class="num">20</span>次，今日还剩余<span
              class="num"
              >{{ AITimes }}</span
            >次(重新生成也消耗次数)
          </div>
        </div>
        <div :class="['input-wrapper', { 'input-wrapper__hover': hasInput }]">
          <el-input
            ref="inputRef"
            type="textarea"
            class="ai-textarea"
            :autosize="{ minRows: 1, maxRows: 5 }"
            placeholder="请输入您的文案创作需求，需求越详细生成的结果越接近您要的答案哦"
            v-model="inputText"
            @keyup.enter.native="createAI(0)"
          />
          <div class="btn-wrapper">
            <img
              class="submit-btn submit-btn_disabled"
              v-if="!hasInput"
              :src="cdnUrl + 'ai-send-disabled.svg'"
              alt=""
            />
            <img
              @click="createAI(0)"
              class="submit-btn"
              v-else
              :src="cdnUrl + 'ai-send.svg'"
              alt=""
            />
          </div>
        </div>
        <div v-if="chatList.length == 0" class="tip-wrap-2">
          <div class="tips">
            每天限使用<span class="num">20</span>次，今日还剩余<span
              class="num"
              >{{ AITimes }}</span
            >次(重新生成也消耗次数)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monkey, AI, AIAgain, AIList } from "@/api/ai/newAi.js";
import handle from "@/components/ai/components/handle.vue";
import loading from "@/components/ai/components/loading.vue";

export default {
  name: "FreeWrite",
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number, // 0: 顶部 1: 短信操作
      default: 0,
    },
  },
  components: {
    handle,
    loading,
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      inputText: "",
      isCreating: false, // 是否创建中，防止重复点击
      chatList: [], // 对话内容
      isNeedAgain: false, // 是否需要重新生成按钮
      timer: null,
      timerNum: 0, // 用于计算10秒内AI应答是否成功
      AITimes: 20, // 剩余次数
    };
  },
  computed: {
    ...mapGetters(["sellerId"]),
    hasInput() {
      return this.inputText && this.inputText.trim().length > 0;
    },
  },
  created() {
    this.AIListFn();
  },
  methods: {
    handleBack() {
      this.$emit("back");
    },
    handleEdit() {
      this.$emit("edit");
    },
    handleRecord() {
      this.$emit("record");
    },
    toggleExpand() {
      this.$emit("toggleExpand");
    },
    handleClose() {
      this.$emit("close");
    },
    showHistoryList() {
      this.$emit("showHistoryList");
    },
    AIListFn() {
      const query = {
        platfromCode: "TB",
        sellerId: this.sellerId || "",
      };
      AIList(query).then((res) => {
        this.AITimes = 20 - Number(res.data.cnt || 0);
        this.chatList = res.data.record || [];
        this.scrollWindow();
      });
    },
    // 生成AI内容
    createAI(type, id) {
      // 0: 生成新内容，1：重新生成内容
      // 检验必填项
      // 条件生成
      // 节流
      if (!this.AITimes) {
        return this.$message.warning("今日次数已用完！");
      }
      if (this.isCreating) {
        return;
      }

      if (!type) {
        // 创建新的AI内容，右侧monkey需要增加一条消息记录
        this.isCreating = true;
        monkey({
          sellerId: this.sellerId || "",
          buildType: 2,
          content: this.inputText,
        })
          .then((res) => {
            // 先生成一条monkey记录，再根据monkey的id请求生成AI应答记录
            if (res.code == 200) {
              this.inputText = "";
              this.chatList.push(res.data);
              this.chatList.push({
                isLoading: true,
                showText: "正在思考...",
                type: 2,
              }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
              this.scrollWindow();
              this.AIFn(res.data.id);
              this.timer = setInterval(() => {
                this.timerNum++;
              }, 1000);
            } else {
              this.isCreating = false;
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.isCreating = false;
          });
      } else {
        // 重新生成AI内容
        if (!id) {
          // 超时未应答，最后一项非聊天列表内容，手动生成新的AI应答
          this.createAI(0);
          return;
        }
        this.isCreating = true;
        AIAgain(id)
          .then((res) => {
            // 重新生成一条monkey记录，再根据monkey的id请求生成AI应答记录
            if (res.code == 200) {
              this.chatList.push(res.data);
              this.chatList.push({
                isLoading: true,
                showText: "正在思考...",
                type: 2,
              }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
              this.scrollWindow();
              this.AIFn(res.data.id);
              this.timer = setInterval(() => {
                this.timerNum++;
              }, 1000);
            } else {
              this.isCreating = false;
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.isCreating = false;
          });
      }
    },
    AIFn(id) {
      // 10秒内无应答不再循环
      if (this.timerNum == 10) {
        clearInterval(this.timer);
        this.timerNum = 0;
        this.isCreating = false;
        this.isRefresh = false;
        this.chatList[this.chatList.length - 1] = {
          showText: "这个接口暂时有点忙，请稍后再试哦~",
          type: 2,
        };
        return;
      }

      // stringA stringB用于做逐字打印效果
      let stringA = { showText: "", type: 2 }; // 逐字存入聊天窗口的内容
      let stringB = { showText: "", type: 2 }; // 完整AI消息内容
      AI(id).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            clearInterval(this.timer);
            this.timerNum = 0; // 成功应答后，10秒计时重置
            this.isNeedAgain = true;
            this.AITimes--; // AI应答成功后手动将次数减一
            stringB = res.data;
            stringA.id = res.data.id;
            AIPrintFn();
            // 逐字打印完之后在放开按钮操作
            setTimeout(() => {
              this.isCreating = false;
            }, stringB.showText.length * 30);
          } else {
            this.AIFn(id);
          }
        } else {
          this.isCreating = false;
          this.$message.error(res.message);
        }
      });

      // 逐字打印效果
      const AIPrintFn = () => {
        this.chatList[this.chatList.length - 1] = stringA;
        this.$forceUpdate();
        this.scrollWindow();
        if (stringA.showText.length >= stringB.showText.length) {
          // 退出递归
          return;
        } else {
          // stringA仍然比stringB短，进入下一次等待和递归
          setTimeout(() => {
            stringA.showText += stringB.showText.charAt(
              stringA.showText.length
            );
            this.scrollWindow();
            AIPrintFn(stringA, stringB);
          }, 30);
        }
      };
    },
    // 滚动AI聊天窗口
    scrollWindow() {
      this.$nextTick(() => {
        const objDiv = document.getElementById("chat_window");
        setTimeout(() => {
          objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
      });
    },
    // 添加到短信输入框
    addFn(item) {
      if (item.indexOf("#自定义短链接#") != -1) {
        this.$message.error(
          "短信文案中包含#自定义短链接#，请使用辅助工具插入短网址！"
        );
      }
      this.handleClose();
      this.$emit("add", item);
    },

    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
  },
};
</script>

<style lang="scss" scoped>
.free-write-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
}

.free-write-container.expanded {
  height: 100%;
  .content-header {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom: none;
  }
  .content-area {
    width: 800px;
    margin: 0 auto;
  }
}

/* 顶部操作栏 */
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  margin-right: 4px;
}

.back-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.back-btn img {
  width: 16px;
  height: 16px;
}

.content-title {
  font-size: 16px;
  font-weight: 500;
}

.content-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

/* 内容区域 */
.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
  position: relative;
  margin-bottom: 20px;
  &__fixed {
    justify-content: flex-start;
  }
}

/* 占位区域 */
.placeholder-section {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.avatar-img {
  width: 309px;
  height: 110px;
}

.placeholder-text {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
  margin: 0;
}

/* 输入区域 */
.input-section {
  padding: 16px;
  position: relative;
  will-change: transform;
  transform-origin: center bottom;
  transition: transform 400ms cubic-bezier(0.4, 0, 0.2, 1), position 0ms 400ms,
    bottom 0ms 400ms, left 0ms 400ms, right 0ms 400ms, z-index 0ms 400ms;
  line-height: normal;
}

.input-section__moving {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  transform: translateY(calc(100% - 91px));
}

.input-section__fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(0);
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.input-wrapper {
  position: relative;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  padding: 12px;
}

.input-wrapper__hover {
  border: 1px solid #3159ff;
}

.ai-textarea {
  width: 100%;
  font-size: 14px;
  padding-right: 12px;
}

.ai-textarea ::v-deep textarea {
  padding: 0px;
  resize: none;
  outline: none;
  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar {
  width: 4px;
  border-radius: 2px;
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar-track {
  background-color: #f3f3f3;
}

.ai-textarea ::v-deep .el-textarea__inner {
  border-color: #e4e7ed;
  border-radius: 8px !important;
  padding-right: 12px;
  border: none !important;
  color: #333;
}

.btn-wrapper {
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.submit-btn_disabled {
  cursor: not-allowed;
}
.submit-btn:hover:not(.submit-btn_disabled) {
  transform: scale(1.05);
}

.chat_window {
  width: 100%;
  height: 100%;
  overflow: auto;
  transition: height 400ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: height;
  &__fixed {
    height: calc(100% - 121px);
  }
  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 20px;
    }

    img {
      width: 40px;
      height: 40px;
    }

    .message {
      position: relative;
      max-width: 450px;
      line-height: 20px;
      font-size: 14px;
      word-break: break-all;

      span {
        white-space: pre-wrap;
      }
    }

    .AI {
      color: #333333;
      padding: 0px;
      max-width: 100%;
    }

    .monkey {
      background: #ddeaff;
      border-radius: 16px;
      color: #333;
      padding: 12px 16px;
    }
  }

  .left {
    justify-content: start;
    padding-bottom: 50px;
    margin-bottom: 0px;
    &:hover {
      .message_handle {
        display: flex;
      }
    }
  }

  .right {
    justify-content: end;
  }
}
.tips {
  color: #666666;
  font-size: 12px;
  margin-top: 2px;

  .num {
    color: #3159ff;
  }
}
.tip-wrap-1 {
  margin-bottom: 16px;
}
.tip-wrap-2 {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
</style>